import styled from '@emotion/styled';
import { numberFormatter } from '@dnhb/formatters';
import Color from 'color';
import LabelIcon from 'images/zelfreflectie/label.svg';

const backgroundColorTransformer = (color, opacity = 0.1) => Color(color).alpha(opacity).rgb().string();
const customPercentageFormatter = value => (value ? numberFormatter(value, 2, 2, '', '%') : '-');

const StyledTable = styled.div`
  font-size: 14px;
  line-height: 20px;
  color: ${({ theme }) => theme.primaryColor};
  text-align: center;

  .row {
    display: flex;

    > div {
      flex: 18.5% 0 1;
      min-width: 18.5%;
      display: flex;
      justify-content: center;
      align-items: center;

      box-sizing: border-box;
      padding: 8px;

      &:first-of-type {
        flex-basis: 26%;
        min-width: 26%;
        justify-content: flex-start;
        padding: 8px 12px;
        text-align: left;
        font-weight: 700;
      }
    }
  }

  .table-header .row > div {
    height: 44px;

    font-weight: 700;
    line-height: 14px;
    
    &.our-rates {
      display: flex;
      padding: 8px 2px;
      background-color: ${({ theme }) => theme.primaryColor};
      border-radius: 5px 5px 0 0;
      
      font-size: 12px;
      text-align: left;
      line-height: 13px;
      font-weight: 800;
      color: ${({ theme }) => theme.secondaryFontColor};
      
      > svg {
        display: block;
        height: 16px;
        width: 16px;
        fill: ${({ theme }) => theme.highlightColor};
        margin-right: 8px;
        @supports (margin: min(8px, 10%)){
          margin-right: min(8px, 10%);
        };
      }
    }

    > img {
      display: block;
      margin: 0 auto;
      max-height: 28px;
      max-width: 60px;

      @supports (object-fit: contain) {
        width: 100%;
        height: 28px;
        object-fit: contain;
        object-position: center;
      }
    }
  }

  .table-body .row {
    background-color: ${({ theme }) => theme.backgroundColor};
    &:nth-of-type(odd) {
      background-color: ${({ theme }) => backgroundColorTransformer(theme.primaryColor)};
      div.our-rates {
        background-color: ${({ theme }) => theme.highlightColor};
      }
    }

    > div {
      min-height: 36px;

      &.our-rates {
        font-weight: 800;
        color: ${({ theme }) => theme.secondaryFontColor};
        background-color: ${({ theme }) => backgroundColorTransformer(theme.highlightColor, 0.65)};
      }

      &:nth-of-type(4) {
        border-left: 1px dashed ${({ theme }) => theme.borderColor};
        border-right: 1px dashed ${({ theme }) => theme.borderColor};
      }
    }
  }
`;

const Table = ({ output: { rows, columns, data } }) => (
  <StyledTable>
    <div className="table-header">
      <div className="row">
        <div />
        <div className="our-rates">
          <LabelIcon />
          Onze<br/>
          Rente
        </div>
        {columns.map(column => (
          <div key={column.label_id}>
            <img
              src={`https://h.hstatic.nl/bank/${column.mortgage_provider_id}/logo-groot`}
              alt={column.label_name}
              title={column.label_name}
            />
          </div>
        ))}
      </div>
    </div>
    <div className="table-body">
      {rows.map(row => {
        const rowData = data[row];
        return (
          <div className="row" key={row}>
            <div>{row === 0 ? 'Variabel' : `${row} jaar vast`}</div>
            <div className="our-rates">{customPercentageFormatter(rowData.main, 2)}</div>
            {columns.map(column => {
              const labelId = column.label_id;
              return <div key={`${row}-${labelId}`}>{customPercentageFormatter(rowData[labelId], 2)}</div>;
            })}
          </div>
        );
      })}
    </div>
  </StyledTable>
);

export default Table;
